import { createFileRoute } from "@tanstack/react-router";
import { PoliciesApp } from "./PoliciesApp";

export const Route = createFileRoute("/policies/")({
  component: PoliciesPage,
});

function PoliciesPage() {
  return <PoliciesApp />;
}
